import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import emoji from '../../../../theme/emoji';
import { TableInfoLegendary } from '../../../molecules/Table/TableInfoLegendary';
import { TableInfoContent } from '../../../molecules/Table/TableInfoContent';
import {
  getNumberOfItemsAccordingAmountDedicatedToNgoAndNgo,
  getRecapAboutNgoItems,
  getStudentNgoSlogan
} from '../../../../domain/ngo/ngo';
import { ContainerTwoThirds } from '../../../layouts/ContainerTwoThirds';
import React from 'react';
import useStyle from './myNgoContribution.style';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import useGoToPage from '../../../../hooks/useGoToPage';
import pages from '../../../../routes/pages';
import { NoteDef } from '../../../../types/note/note.def';
import {
  Enum_Commande_Status,
  Enum_Userspermissionsuser_Ong
} from '../../../../graphql/generated/graphql';
import { classNames } from '../../../../helpers/style/classNames';
import { Modal } from 'components/organisms/Modals/Modal';
import { IconButton } from '../../../atoms/Buttons/IconButton';
import { myNgoExplanation } from '../../../../domain/ngo/ngoTableExplanations';
import TableExplanations from '../TableExplanation';

type StudentType = {
  note: NoteDef;
  ngo: Enum_Userspermissionsuser_Ong;
  commandesLength: number;
  ordersWithContribution: Array<{
    status: Enum_Commande_Status;
    customerContributedToTheOng: boolean;
  }>;
};
interface MyNgoContributionProps {
  student: StudentType;
  contribution: {
    total: number;
    contributionFC: number;
    customersContribution: number;
    customersEngagement: number;
    ngo: Enum_Userspermissionsuser_Ong;
  };
}
export const MyNgoContribution = ({
  student,
  contribution
}: MyNgoContributionProps) => {
  const classes = useStyle();
  const goToNgoChoice = useGoToPage(pages.NGO_CHOICE_PAGE.path, {
    type: 'user'
  });
  return (
    <>
      {!student.ngo && (
        <FeatureContainer withPadding={true}>
          <div className={classes.textButtonContainer}>
            <p>Aucune ONG séléctionnée pour le moment</p>
            <ButtonWithText
              variant="primaryBlue"
              content={'Je choisis mon ONG'}
              onClick={goToNgoChoice}
            />
          </div>
        </FeatureContainer>
      )}
      {student.ngo && (
        <ContainerTwoThirds
          col1={
            <div className={classes.container}>
              <FeatureContainer>
                <div className={classes.header}>
                  <div className={classes.title}>
                    <h2>Mes chiffres</h2>
                    <img
                      className={classes.emoji}
                      src={emoji['BarChart'].url}
                      alt={emoji['BarChart'].alt}
                    />
                  </div>
                  <Modal
                    modalHead={'Comprendre ce tableau'}
                    triggerButton={
                      <IconButton
                        icon="Info"
                        variant="backless"
                        onClick={() => null}
                      />
                    }
                  >
                    <TableExplanations textExplanations={myNgoExplanation} />
                  </Modal>
                </div>
                <div className={classes.tableResult}>
                  <TableInfoLegendary
                    legends={[
                      'Taux d\'engagement "1 €" de mes clients (%)',
                      'Somme "1€" de mes clients (€)',
                      'ONG choisie pour mes "1 €"'
                    ]}
                  />
                  <TableInfoContent
                    color="Blue"
                    contents={[
                      `${contribution.customersEngagement}%`,
                      `${contribution.customersContribution}€`,
                      `${contribution.ngo}`
                    ]}
                  />
                </div>
              </FeatureContainer>
            </div>
          }
          col2={
            <div
              className={classNames([
                classes.ngoItemContainer,
                classes[student.ngo]
              ])}
            >
              <p className={classes.slogan}>
                {getStudentNgoSlogan(student.ngo)}
              </p>
              <div className={classes.itemsContainer}>
                <p className={classes.numberOfItems}>
                  {getNumberOfItemsAccordingAmountDedicatedToNgoAndNgo(
                    contribution.customersContribution,
                    student.ngo
                  )}
                </p>
                <p className={classes.recapItems}>
                  {getRecapAboutNgoItems(
                    contribution.customersContribution,
                    student.ngo
                  )}
                </p>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};
